import { Component, Input, OnInit } from '@angular/core';
import { Project } from 'src/app/shared/models';

@Component({
    selector: 'app-project-lookups',
    templateUrl: './project-lookups.component.html',
    styleUrls: ['./project-lookups.component.scss'],
    standalone: false
})
export class ProjectLookupsComponent implements OnInit {

  @Input() project: Project;

  constructor() { }

  ngOnInit(): void {
  }

}
